'use client'

import { useActionState } from 'react'
import { submitContact, type ContactFormState } from '@/app/contact/actions'
import Button from '@/components/ui/Button'
import { CONTENT_NAME, EXPLANATION, PANEL, SECOND_LINE } from '@/components/seo/roles'

const initialState: ContactFormState = { ok: false, error: null }

const fieldClass =
  'w-full rounded-xl border border-[var(--app-border)] bg-[var(--app-card)] px-4 py-3 text-body text-[var(--rt-ink)] placeholder:text-[var(--rt-ink-faint)] transition-colors focus:border-[color-mix(in_oklch,var(--rt-accent)_50%,transparent)] focus:outline-none'

export default function ContactForm() {
  const [state, formAction, pending] = useActionState(submitContact, initialState)

  if (state.ok) {
    return (
      <div className={`${PANEL} space-y-3`}>
        <p className={CONTENT_NAME} role="status">
          Thanks, we got your message.
        </p>
        <p className={EXPLANATION}>
          We read everything. If you left an email, we&apos;ll reply when we can.
        </p>
      </div>
    )
  }

  return (
    <form action={formAction} className="space-y-5">
      {/* Honeypot — hidden from humans, bots fill it; server silently accepts. */}
      <input
        type="text"
        name="website"
        tabIndex={-1}
        autoComplete="off"
        className="hidden"
        aria-hidden="true"
      />

      <label className="block space-y-2">
        <span className={SECOND_LINE}>Email (optional, if you want a reply)</span>
        <input
          type="email"
          name="email"
          autoComplete="email"
          maxLength={320}
          className={fieldClass}
          placeholder="you@example.com"
        />
      </label>

      <label className="block space-y-2">
        <span className={SECOND_LINE}>Message</span>
        <textarea
          name="message"
          required
          rows={8}
          maxLength={5000}
          className={`${fieldClass} resize-y min-h-[180px]`}
          placeholder=""
        />
      </label>

      {state.error && (
        <p className="text-body-sm text-[var(--rt-danger)]" role="alert">
          {state.error}
        </p>
      )}

      <Button type="submit" variant="primary" size="md" disabled={pending}>
        {pending ? 'Sending…' : 'Send message'}
      </Button>
    </form>
  )
}
